var map = {
	"./about/aboutRight.png": 60,
	"./about/aboutleft.png": 61,
	"./about/abouttop1.png": 62,
	"./about/main.png": 63,
	"./blog/blogmain.png": 237,
	"./breathe/Icon02.png": 64,
	"./breathe/Icon03.png": 65,
	"./breathe/main.png": 66,
	"./contact/main.png": 67,
	"./faqs/Image 02.png": 238,
	"./faqs/Image 03.png": 239,
	"./faqs/main.png": 68,
	"./newsevent/main.png": 69,
	"./newsevent/newseventcenter.png": 70,
	"./newsevent/newseventleft.png": 71,
	"./newsevent/newseventright.png": 72,
	"./partnerwithus/Image02.png": 73,
	"./partnerwithus/Image03.png": 74,
	"./partnerwithus/main.png": 75,
	"./service/Image02.png": 76,
	"./service/Image03.png": 77,
	"./service/main.png": 78,
	"./treatment/main.png": 79,
	"./treatment/top.png": 80,
	"./virtualtour/Image01.png": 81,
	"./virtualtour/Image02.png": 82,
	"./virtualtour/Image03.png": 83,
	"./virtualtour/main.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;